// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"225156a9","260":"7728ce7d","319":"a0ff7ee9","326":"3abb20c3","373":"a17fe057","384":"81e51457","418":"1c0460f8","449":"513e0282","533":"054d2448","603":"f56dc3c8","660":"5edc96b5","838":"74f1c5a5","980":"1ed46b37"}[chunkId] + ".js";
};